import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import MvpMailSubscription from '../MvpMailSubscription';
import { LoaderIcon, ErrorIcon, SuccessIcon } from '../../react/eagerlyIcons/src/__generated__/icons';

export default class EagerlyMailSubscription {
  constructor(element) {
    this.root = ReactDOMClient.createRoot(element);
    this.jsonUrl = element.dataset.jsonUrl;

    this.init();
  }

  init() {
    this.root.render(
      <React.StrictMode>
        <MvpMailSubscription jsonUrl={this.jsonUrl} LoaderIcon={LoaderIcon} ErrorIcon={ErrorIcon} SuccessIcon={SuccessIcon} />
      </React.StrictMode>
    );
  }
}
